///// <reference path="../../../../typings/tsd.d.ts" /> 
//module warsApp.controllers {
//    export interface IWorkflowClaimsConfiguration extends angular.IScope {
//        model: models.ClaimsConfigurationModel;
//    }
//    export class WorkflowClaimsConfigurationController implements IController {
//        scope: IWorkflowClaimsConfiguration;
//        constructor($scope: IWorkflowClaimsConfiguration,
//            claimDefinitionService: services.ClaimDefinitionService,
//            processConfigurationService: warsApp.services.ProcessConfigurationService,
//            claimsAssignmentService: warsApp.services.ClaimsAssignmentConfigurationService,
//            $routeParams: angular.route.IRouteParamsService)
//        {
//            this.scope = $scope;
//            var processConfigId = $routeParams["id"];
//            this.scope.model = new models.ClaimsConfigurationModel(processConfigId,
//                claimsAssignmentService, claimDefinitionService, processConfigurationService);
//        }
//    }
//}
//warsApp.registerController('WorkflowClaimsConfigurationController', ['$scope', 'claimDefinitionService', 'processConfigurationService', 'claimsAssignmentConfigurationService', '$routeParams' ]);
//# sourceMappingURL=WorkflowClaimsConfigurationController.js.map